/** Console disablen bei IE **/
if (typeof console === "undefined" || typeof console.log === "undefined" || typeof console.group === "undefined") {
    window.console = {
        log: function () {
        }, warn: function () {
        }, error: function () {
        }, dir: function () {
        },
        group: function () {
        }, groupEnd: function () {
        }, debug: function () {
        }, info: function () {
        },
        assert: function () {
        }, count: function () {
        }, dirxml: function () {
        }, profile: function () {
        },
        profileEnd: function () {
        }, time: function () {
        }, timeEnd: function () {
        }, trace: function () {
        }
    };
}